import { render, staticRenderFns } from "./EventActions.vue?vue&type=template&id=72bb3765&scoped=true&"
import script from "./EventActions.vue?vue&type=script&lang=js&"
export * from "./EventActions.vue?vue&type=script&lang=js&"
import style0 from "./EventActions.vue?vue&type=style&index=0&id=72bb3765&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bb3765",
  null
  
)

export default component.exports